export const hexToHsl = (hex) => {
  if (!hex || hex.length < 7) return null;
  const r = parseInt(hex.slice(1, 3), 16) / 255;
  const g = parseInt(hex.slice(3, 5), 16) / 255;
  const b = parseInt(hex.slice(5, 7), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
    h /= 6;
  }
  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
};

export const contrastFg = (hex) => {
  if (!hex || hex.length < 7) return "0 0% 100%";
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.6 ? "195 45% 10%" : "0 0% 100%";
};

export const BRAND_PALETTE = ["#94ae8f", "#c0913f", "#4a7fa5", "#c26a4a", "#7d5a75", "#c76d7e", "#4a6b52", "#1e5f6e"];

const HEX = /^#[0-9a-fA-F]{6}$/;

const relLum = (hex) => {
  const c = [1, 3, 5].map((i) => {
    const v = parseInt(hex.slice(i, i + 2), 16) / 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
};

// WCAG contrast ratio between two hex colours (1 = identical, 21 = black vs white).
export const contrastRatio = (hex1, hex2) => {
  if (!HEX.test(hex1 || "") || !HEX.test(hex2 || "")) return null;
  const l1 = relLum(hex1), l2 = relLum(hex2);
  return (Math.max(l1, l2) + 0.05) / (Math.min(l1, l2) + 0.05);
};
